import { render, staticRenderFns } from "./CommonReportChart.vue?vue&type=template&id=1b94f58b&scoped=true"
import script from "./CommonReportChart.vue?vue&type=script&lang=ts"
export * from "./CommonReportChart.vue?vue&type=script&lang=ts"
import style0 from "./CommonReportChart.vue?vue&type=style&index=0&id=1b94f58b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b94f58b",
  null
  
)

export default component.exports